<div class="wrapper">
    <div class="center">
        <h2>¿<b>Necesitas</b> asesoría?</h2>
        <p>Te asesoramos con el vehículo y tipo de financiamiento, ¡Déjanos tus datos! Te ayudamos a hacer tu
            precalificación en minutos</p>
    </div>

    <form [formGroup]="formData" (ngSubmit)="onSubmit()" id="recaptForm">
        <input type="hidden" class="hidden" name="captcha_settings"
            value='{"keyname":"reCaptchaBitcarWeb_01","fallback":"true","ts":""}' />
        <input type="hidden" class="hidden" name="retURL" value="http://www.google.com.mx" />
        <input type="hidden" class="hidden" id="g-recaptcha-response" name="g-recaptcha-response" />
        <input type="hidden" class="hidden" id="company" name="company" value="[[Unknown]]" />
        <input type="hidden" class="hidden" id="00NPb00000JPFwz" maxlength="100" name="00NPb00000JPFwz" size="20"
            value="wtl_bitcar_form" />
        <input type="hidden" class="hidden" id="00NPb00000JPH9B" maxlength="20" name="00NPb00000JPH9B" size="20"
            value="7018c000000GKM1AAO" />

        <input type="hidden" class="hidden" id="lead_source" maxlength="100" name="lead_source"
            formControlName="lead_source" value="" />
        <div class="two-col">
            <div class="input-wrapper" for="first_name">
                <label for="">*Nombre</label>
                <input id="first_name" maxlength="40" name="first_name" size="20" type="text"
                    formControlName="first_name" />
            </div>
            <div class="input-wrapper">
                <label for="last_name">*Apellido</label>
                <input id="last_name" maxlength="80" name="last_name" size="20" type="text"
                    formControlName="last_name" />
            </div>
            <div class="input-wrapper">
                <label for="email">*Correo</label>
                <input id="email" maxlength="80" name="email" size="20" type="text" formControlName="email" />
                <div *ngIf="emailControl?.errors?.['invalidEmail']" style="color: red;">
                    El formato del correo electrónico no es válido.
                </div>
            </div>
            <div class="input-wrapper">
                <label for="phone">*Teléfono</label>
                <input id="phone" maxlength="40" name="phone" size="20" type="text" formControlName="phone" />
                <div *ngIf="phoneControl?.errors?.['invalidPhoneFormat']" style="color: red;">
                    El teléfono debe contener exactamente 10 dígitos numéricos.
                </div>
                <div *ngIf="phoneControl?.errors?.['allSameDigits']" style="color: red;">
                    El teléfono no puede consistir en el mismo dígito repetido.
                </div>
            </div>
            <div class="input-wrapper">
                <label for="">*¿Qué tipo de régimen tienes?</label>
                <select id="00NPb00000JOl2r" name="00NPb00000JOl2r" title="Régimen fiscal"
                    formControlName="regimen_fiscal">
                    <option value="">--Ninguno--</option>
                    <option value="RESICO">RESICO</option>
                    <option value="Empleado/Asalariado">Empleado/Asalariado</option>
                    <option value="PFAE">PFAE</option>
                </select>
            </div>
            <div class="input-wrapper">
                <label for="">*Nivel de ingresos mensuales</label>
                <select id="00N8c00000hQda8" name="00N8c00000hQda8" title="Rango ingresos"
                    formControlName="00N8c00000hQda8">
                    <option value="">--Ninguno--</option>
                    <option value="Entre 30 y 40 mil">Entre 30 y 40 mil</option>
                    <option value="Entre 40 y 50 mil">Entre 40 y 50 mil</option>
                    <option value="Mas de 50 mil">Mas de 50 mil</option>
                </select>
            </div>
        </div>
        <div class="input-wrapper">
            <label for="">*RFC</label>
            <input id="00N8c00000WBdCa" maxlength="30" name="00N8c00000WBdCa" size="20" type="text"
                formControlName="00N8c00000WBdCa" />
            <div *ngIf="rfcControl?.errors?.['invalidRfc']" style="color: red;">
                El formato del RFC no es válido.
            </div>
        </div>
        <div class="input-wrapper">
            <label for="">*Has tenido créditos</label>
            <select id="00NPb00000JOm5N" name="00NPb00000JOm5N" title="Has tenido créditos"
                formControlName="00NPb00000JOm5N">
                <option value="">--Ninguno--</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
            </select>
        </div>
        <div class="input-wrapper">
            <label for="">¿Tienes un vehículo en mente? ¿Cuál? (opcional)</label>
            <input id="00NPb00000JOnW5" maxlength="255" name="00NPb00000JOnW5" size="20" type="text"
                formControlName="00NPb00000JOnW5" />
        </div>
        <!--  <div class="input-wrapper check">
            <input type="checkbox" name="" id="">
            <label for="">Acepto ser contactado por BitCar para recibir asesoría sobre planes de financiamiento y
                autorizo para que mis datos sean usados para consultar mi Buró de Crédito.</label>
        </div>
        <div class="input-wrapper check">
            <input type="checkbox" name="" id="">
            <label for="">He leído y acepto la Politica de privacidad</label>
        </div> -->

        <div class="center">
            <button id="send" [disabled]="isSubmitting || formData.invalid"><mat-icon>phone_in_talk</mat-icon>Quiero que
                me contacten</button>
        </div>

        <input type="hidden" class="hidden" id="utm_campaign" maxlength="255" name="00NPb00000JPXFZ" size="20"
            formControlName="00NPb00000JPXFZ" />
        <input type="hidden" class="hidden" id="utm_campaign_name" maxlength="255" name="00NPb00000JPXST" size="20"
            type="text" formControlName="00NPb00000JPXST" />
        <input type="hidden" class="hidden" id="utm_content" maxlength="255" name="00NPb00000JPY8P" size="20"
            type="text" formControlName="00NPb00000JPY8P" />
        <input type="hidden" class="hidden" id="utm_medium" maxlength="255" name="00NPb00000JPQVq" size="20" type="text"
            formControlName="00NPb00000JPQVq" />
        <input type="hidden" class="hidden" id="utm_term" maxlength="255" name="00NPb00000JPYd3" size="20" type="text"
            formControlName="00NPb00000JPYd3" />
        <input type="hidden" class="hidden" id="utm_source" maxlength="255" name="00NPb00000JPWjL" size="20" type="text"
            formControlName="00NPb00000JPWjL" />
    </form>
</div>